import {Rectangle, Graphics} from 'pixi.js';
import type {SafeZone} from '@gongxigames/framework/core/fragments/display/SafeZone/SafeZone';

export type FullScreenFaderV2Options = {
    safeZone: SafeZone;
    name?: string;
    color?: number;
    opacity?: number;
};

export class FullScreenFaderV2 extends Graphics {
    private readonly tmpRectangle = new Rectangle();

    constructor(options: FullScreenFaderV2Options) {
        super();

        this.name = options.name ?? 'FullScreenFaderV2';

        this
            .clear()
            .beginFill(options.color || 0, options.opacity || 0.6)
            .drawRect(0, 0, 1, 1)
            .endFill();

        this.resize(options.safeZone);
    }

    public resize(safeZone: SafeZone): void {
        const {tmpRectangle} = this;

        safeZone.calcInSafeFader(tmpRectangle);

        this.position.copyFrom(tmpRectangle);
        this.width = tmpRectangle.width;
        this.height = tmpRectangle.height;
    }
}